import { Component, OnInit, Input } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UsersService } from '../../../services/users/users.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-edit-user-modal',
  templateUrl: './edit-user-modal.component.html',
  styleUrls: ['./edit-user-modal.component.scss'],
})
export class EditUserModalComponent implements OnInit {
  @Input() user;
  public userAction = 'Add';
  public roleId = '0';
  public roleError = false;
  constructor(
    private SpinnerService: NgxSpinnerService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private UsersService: UsersService
  ) {}

  ngOnInit(): void {
    if(this.user) {
      this.userAction = 'Edit';
    }
  }

  close() {
    this.modalService.dismissAll();
  }

  addUser(user:NgForm){
    if (!user || !user.valid) return;
    if(this.roleId=='0') return this.roleError = true;
    var userToSend ={
      user:user.form.value
    }
    this.roleError = false;
    userToSend.user.roleId = this.roleId;
    this.UsersService.register(userToSend).then((result:any)=>{
      console.log('>>>', result);
      if(result.msg=== "you are already registered "){
        this.toastr.error('User already exists');
      }
      else  {
        this.toastr.success('User added successfully');
        this.close();
      }
    }).catch((err)=>{
      err = err || new Object();
    });
  }

  update() {
    this.SpinnerService.show();
    this.UsersService.updateUser(this.user.id, this.user.name)
      .then((res) => {
        this.SpinnerService.hide();
        let response = JSON.parse(JSON.stringify(res));
        if (response.success) {
          this.toastr.success('User updated');
          this.close();
        } else {
          this.toastr.error('User not updated');
        }
      })
      .catch(() => {
        this.close();
        this.toastr.error('User not updated');
        this.SpinnerService.hide();
      });
  }
}
